import React from 'react';

function Dashboard() {
  return (
    <div>
      <h2>Welcome to Your Dashboard</h2>
      {/* Add dashboard content here */}
    </div>
  );
}

export default Dashboard;
